import IState from '../interfaces/IState';
import { DEEPOMATIC_ARRAY_LENGTH, SKIP_LTE_CHECK } from '../utils/constants';

export const stateData: IState = {
    deepomatic: new Array(DEEPOMATIC_ARRAY_LENGTH).fill(null),
    inspect: {
        canPerformInstallation: false,
        pdlValidated: false,
    },
    tabsEnabled: {
        inspect: true,
        wire: false,
        mesh: false,
        test: false,
        doc: false,
    },
    wire: {
        skipLteDbox: SKIP_LTE_CHECK ? true : false,
    },
    mesh: {
        skipFwUpdate: false,
        skipBleValidation: false,
        meshCompleted: false,
    },
    test: {
        skipTests: false,
        testsPassed: {},
    },
    signature: {
        calibrationAck: false,
        businessAck: false,
    },
    document: {
        everythingCleaned: false,
    },
    guideCustomer: {
        downloadApp: false,
        loginToApp: false,
        setupHeatingSchedule: false,
        saveHeaterSetup: false,
        explainUserManualLocation: false,
    },
};
